export default "__VITE_ASSET__CA3s11BU__"